// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__NIBG8","Tag___isActive":"Tag_Tag___isActive__K0kd1","Tag_tooltip":"Tag_Tag_tooltip__9PZ2w"};